import type { FaireProductEntity } from "../../entity_types/product";

export const p_nx2gr93e4h: FaireProductEntity = {
  token: "p_nx2gr93e4h",
  type: "product",
  name: "Blue Hydrangea Framed Art",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/7d95964cacf223ac6216095f00bcc7817e260405fd80a38ca5e8ed4b4c38d3a4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f582c7c6ef7052439debf06c9b72a4f060cb3a090dc2da06287fb67a75f5608c.jpeg",
    "https://cdn.faire.com/fastly/73631e1dd0a37ffaf84006262bed2adf625f70de3bc3913b892389364e27a832.jpeg",
    "https://cdn.faire.com/fastly/7a2c6158177a1a02aaf4b846497ece99832861dc7ec5cf17f7f938bdd87b7722.jpeg",
    "https://cdn.faire.com/fastly/97dc0717b3e8f56ee0a51588fc02aa12d093980bd0ce8fbfe2d760baf7025542.jpeg"
  ],
  priceDollars: 5,
  description: "A mini framed art piece from our Botanical Collection displaying art of a blue hydrangea and butterfly inside a sculpted frame with a metallic gold wash for a vintage style. Botanical design is replicated from original art hand painted in a delicate watercolor style. Our Blue Hydrangea framed art easily adds a touch of elegance to any space with multiple display options including an attached hanger and magnet for hanging as well as a removable easel to free stand on a shelf or tabletop. A botanical home accent perfect for adding vintage style to any home or work space.",
  tags: [],
  msrpDollars: 9.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:40.138Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
